import React from 'react'
import closeMenu from '../../Images/closeMenu.png'
import tiktok from '../../Images/tiktok.png';
import facebook from '../../Images/facebook.png';
import instagram from '../../Images/instagram.png';
import './Menu.scss';
import $ from 'jquery';

export default function Menu({ navigateTo, setShowMenu }) {

    return (
        <div className="Menu">
            <div className="MenuHeader">
                <img onClick={() => {                    
                    setShowMenu(false)
                }} src={closeMenu} alt="" />
            </div>
            <div className="MenuMain">
                <h1 onClick={() => {                    
                    navigateTo("")
                }}>Home</h1>
                <h1 onClick={() => {                    
                    navigateTo("products")
                }}>Products</h1>
                <h1 onClick={() => {                    
                    navigateTo("verify")
                }}>Verify</h1>
                <h1 onClick={() => {                    
                    navigateTo("about")
                }}>About</h1>
                <h1 onClick={() => {                    
                    navigateTo("wholesale")
                }}>Wholesale </h1>
                <h1 onClick={() => {                    
                    navigateTo("support")
                }}>Support </h1>
            </div>
            <div className="MenuSocialMedia">
                <img src={tiktok} alt="" />
                <img src={facebook} alt="" />
                <img src={instagram} alt="" />
            </div>
            <div className="MenuFooter">
                <h5>Copyright © 2023 BUMP. All rights reserved.</h5>
            </div>
        </div>
    )
}
